export default {
  namespaced:true,
  state:{
    token:'',
    userInfo:{},    //用户基本信息
    rule: [],       //用户权限列表
  },
  mutations:{
    setToken(state,token){
      state.token = token
    },
    setUserInfo(state,userInfo){
      state.userInfo = userInfo
    },
  },
  getters:{

  },
  actions:{
    login({commit},{token,userInfo,menus}){
      commit('setToken',token)
      commit('setUserInfo',userInfo)
    },
    loginOut({commit}){
      commit('setToken','')
      commit('setUserInfo',{})
    }


  }
}